import React, { useEffect } from "react";
import "../styles/SessionExpiryModal.css";

const pad = (value) => String(Math.max(0, value)).padStart(2, "0");

export default function SessionExpiryModal({ open, remainingSeconds = 0, renewing = false, onContinue, onLater, onLogout }) {
    useEffect(() => {
        if (!open) return undefined;
        const onKeyDown = (event) => {
            if (event.key === "Escape" && !renewing) onLater?.();
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [open, renewing, onLater]);

    if (!open) return null;

    const minutes = Math.floor(Math.max(0, remainingSeconds) / 60);
    const seconds = Math.max(0, remainingSeconds) % 60;

    return (
        <div className="sessionExpiryOverlay" role="presentation">
            <section className="sessionExpiryCard" role="dialog" aria-modal="true" aria-labelledby="session-expiry-title">
                <div className="sessionExpiryIcon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" focusable="false">
                        <circle cx="12" cy="12" r="8.5" />
                        <path d="M12 7.5v5l3.2 2" />
                    </svg>
                </div>

                <div className="sessionExpiryHeading">
                    <span>Seguridad de sesión</span>
                    <h2 id="session-expiry-title">Tu sesión está por finalizar</h2>
                    <p>¿Deseas continuar trabajando en MovilesPay?</p>
                </div>

                <div className="sessionExpiryTimer" aria-live="polite">
                    <small>Tiempo restante</small>
                    <strong>{pad(minutes)}:{pad(seconds)}</strong>
                    <span>Al llegar a 00:00 se cerrará la sesión automáticamente.</span>
                </div>

                <div className="sessionExpiryInfo">
                    Si continúas, se generará una nueva sesión válida por 24 horas. Si eliges “Ahora no”, podrás usar el tiempo restante y luego volverás automáticamente al login.
                </div>

                <div className="sessionExpiryActions">
                    <button type="button" className="sessionExpiryLogout" onClick={onLogout} disabled={renewing}>
                        Cerrar sesión
                    </button>
                    <button type="button" className="sessionExpiryLater" onClick={onLater} disabled={renewing}>
                        Ahora no
                    </button>
                    <button type="button" className="sessionExpiryContinue" onClick={onContinue} disabled={renewing} autoFocus>
                        {renewing ? "Renovando..." : "Continuar sesión"}
                    </button>
                </div>
            </section>
        </div>
    );
}
